import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, Validator } from '@angular/forms';
import { ErrorService } from '../services/error.service';
import { NewLoginService } from '../services/new-login.service';

@Directive({
	selector: '[appValidateUsername][formControlName],[appValidateUsername][formControl],[appValidateUsername][ngModel]',
	providers: [
		{
			provide: NG_ASYNC_VALIDATORS,
			useExisting: forwardRef(() => UsernameValidator),
			multi: true
		}
	]
})
export class UsernameValidator implements Validator {
	constructor(private _errorService: ErrorService,
				private _newLoginService: NewLoginService) {
	}

	validate(c: AbstractControl): Promise<{ [key: string]: any }> {
		return new Promise(resolve => {
			if (c.value == null || c.value.length === 0) {
				resolve(null);
			} else {
				this._newLoginService.usernameIsValid(c.value.trim()).subscribe(response => {
					// response from usernameIsValid is reversed for some reason, so false means username IS valid
					if (response === false) {
						resolve(null);
					} else {
						resolve({usernameTaken: true});
					}
				});
			}
		});
	}
}
